// These headers match the headers set in paginated api responses.
// See app/controllers/concerns/pagination_header_writing.rb
const PAGINATION_PAGE_HEADER = "X-Page"
const PAGINATION_PAGE_SIZE_HEADER = "X-Page-Size"
const PAGINATION_TOTAL_COUNT_HEADER = "X-Total-Count"
const PAGINATION_TOTAL_PAGES_HEADER = "X-Total-Pages"

// Initialize by passing a response from the API.
// See app/javascript/services/api.js
export default class ApiResponsePaginationHeaders {
  constructor(apiResponse) {
    this.page = Number(apiResponse.headers.get(PAGINATION_PAGE_HEADER)) || undefined
    this.perPage = Number(apiResponse.headers.get(PAGINATION_PAGE_SIZE_HEADER)) || undefined
    this.totalCount = Number(apiResponse.headers.get(PAGINATION_TOTAL_COUNT_HEADER)) || undefined
    this.totalPages = Number(apiResponse.headers.get(PAGINATION_TOTAL_PAGES_HEADER)) || undefined
  }
}
